export default __webpack_public_path__ + "static/media/vavideo.ed7c0d05.mp4";